const locale = {
	DASHBOARDS: 'Dashboards',
	DASHBOARD_USER: 'User Dashboard',
	DASHBOARD_KPIS: 'KPIs Dashboard',
	DASHBOARD_POWERBI_STATS: 'PowerBI stats',

	REGISTRIES: 'Registries',
	COMPANIES: 'Companies',
	CUSTOMERS: 'Customers',
	SUPPLIERS: 'Suppliers',
	OTHERS: 'Others',
	PEOPLE: 'People',
	ITEMS: 'Items',
	CONTACTS: 'Contacts',
	MAILS: 'Mail Addresses',
	PHONENUMBERS: 'Phone numbers',
	SOCIALNETWORKS: 'Social networks',

	MARKETING: 'Marketing',
	MARKETINGACTIONS: 'Marketing Actions',
	DEMS: 'DEMs',

	SALES: 'Sales',
	COMMERCIALCAMPAIGNS: 'Commercial Campaigns',
	OPPORTUNITIES: 'Opportunities',
	NAV_QUOTATIONS: 'NAV Quotations',
	NAV_ORDERS: 'NAV Orders',
	CONTRACTS: 'Contracts',
	ORDERS: import.meta.env.VITE_ENDPOINT === 'https://crm.borcianiebonazzi.com' ? 'Order Proposals' : 'Quotations',

	MANAGEMENT: 'Task Management',
	PROJECTS: 'Projects',
	ACTIVITIES: 'Activities',
	WORKREPORTS: 'Work Reports',
	CHRONOLOGY: 'Chronology',
	TICKETS: 'Tickets',
	PHONECALLS: 'Phone Calls',

	SYSTEM: 'System',
	TAGS: 'Tags',
	USERS: 'Users',
	GROUPS: 'Groups',
	RECYCLE_BIN: 'Recycle Bin',
	LOGS: 'System Logs',
	EXCHANGE_MAILS_LOGS: 'Exchange mails logs',
	SYSTEM_TABLES: 'System tables',
	PERMISSIONS_MANAGEMENT: 'Permissions Management',
	SETTINGS: 'Settings'
};

export default locale;
